import * as types from './types';
import api from '../api/index.js';
import VueCookies from 'vue-cookies';
import config from '@/utils/config.js';
export default {
    setUserInfo({commit},data=null){
        commit(types.SET_USERINFO,data)
    },
    setToken({commit},data=null){
        console.log('setToken');
        data ? VueCookies.set('token',data) : VueCookies.remove('token'); 
        commit(types.SET_TOKEN,data)
    },
    setRegParams({commit},data=null){
        data ? VueCookies.set('regParams',data) : VueCookies.remove('regParams'); 
        commit(types.SET_REGPARAMS,data)
    },
    //获取用户数据
    async getUserInfo({commit}){
        const res = await api.userInfo();
        return new Promise((resolve, reject)=>{
            if(res.code == config.RESOK){
                let userInfo = res.data;
                commit(types.SET_USERINFO,userInfo);
                resolve(userInfo)
            } else{
                VueCookies.remove('token')
                commit(types.SET_TOKEN,null)
                reject(res);
            }
        })
    }
  
}